module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_oberiberg-6cea202b73aff89e6cae63ad51c52a20.png";